import MensureLoader from './MensureLoader.jsx';

export default MensureLoader;
